import script from "./Loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loading.vue?vue&type=script&lang=ts&setup=true"

import "./Loading.vue?vue&type=style&index=0&id=f6028c7e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6028c7e"]])

export default __exports__